<template>
  <ul>
    <slot></slot>
  <li v-for="data in list">
    <b-row>
      <b-col>
        <span class="detail-label">{{data.title}} :</span>
      </b-col>
      <b-col class="detail-value">
        <span v-if="!data.pipe">{{source[data.attribut]  | if_null}}</span>
        <span v-if="data.pipe==='in_euro'">{{source[data.attribut]  | in_euro}}</span>
        <span v-if="data.pipe==='sexe'">{{source[data.attribut]  | sexe}}</span>
        <span v-if="data.pipe==='in_minutes'">{{source[data.attribut]  | in_minutes}}</span>
        <span v-if="data.pipe==='sensation'">{{source[data.attribut]  | sensation}}</span>
        <span v-if="data.pipe==='date'">{{source[data.attribut]  | date}}</span>
        <span v-if="data.pipe==='cascade_attribut'">{{source[data.attribut[0]][data.attribut[1]]}}</span>
      </b-col>
    </b-row>
  </li>
  </ul>
</template>

<script>
    export default {
        name: "list-show",
        props:['list','source']
    }
</script>

<style scoped>
.badge-payee{
  color: #fff;
  background-color: #00ab2b;
}
.badge-non-payee{
  color: #fff;
  background-color: #dc3545;
}
</style>
